import React from 'react';
import { withStyles } from 'material-ui/styles';
import UIButton from '../../core/ui/button.js';
import HandlersDialog from './handlers_dialog.js';

const styles = theme => ({
  root: {
    width: '100%',
  }
});

class Result extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      selectedHandlers : [],
    }
    this.handlersDialog = null;
    this.onHandlerSelected = this.onHandlerSelected.bind(this);
  }

  onHandlerSelected(selection){
    var url = '/google/admin/handler';
    var params = {h: selection.name, r: selection.renderer, e: selection.extractor};
    this.props.server.get(url, params, function(resp){});

    this.state.selectedHandlers.push(selection);
    this.setState({selectedHandlers: this.state.selectedHandlers});
  }

  componentDidMount(){
    if(this.props.handlers){
      this.props.handlers.map(h =>
        this.state.selectedHandlers.push({name: h.name, type: h.type, renderer: h.renderer.name, extractor: h.extractor.name})
      )
      this.setState({selectedHandlers : this.state.selectedHandlers});    
    }
  }

  render() {
    var k = 0;
    const classes = this.props.classes;
    /*
    <h2>Registered handlers</h2>
      {this.state.selectedHandlers.map(handler =>
        <div key={k++}>[{handler.name}] => [{handler.type}] {handler.renderer}({handler.extractor})</div>            
      )}
    <UIButton onClick={() => {this.handlersDialog.doShow()}}>Handlers</UIButton>
    <HandlersDialog onRef={(item) => {this.handlersDialog = item;}} item={this.props.item} onSelected={this.onHandlerSelected}/>    
    */
    return (
      <div className={classes.root}>
        <h1>Debug Mode</h1>
        <h2>Rendered inventory</h2>
        <h3>Results</h3>
        {this.props.results && this.props.results.map(result =>
          <div key={k++}>[{result.hook}] => {result.renderer.name}</div>
        )}        
        <h3>Pieces</h3>
        {this.props.pieces && this.props.pieces.map(piece =>
          <div key={k++}>[{piece.hook}] => {piece.renderer.name}</div>
        )}        
      </div>
    );
  }
}

export default withStyles(styles)(Result);


// WEBPACK FOOTER //
// ./src/search/admin/result.js